import Link from 'next/link';
import {usePathname} from 'next/navigation';

import CSS from './URLs.module.scss';
import CSSUtility from '@/styles/utility.module.scss';
import Focus from '@/components/elements/Focus';
import Vector from '@/components/elements/vector/Vector';
import {resolveRoute} from '@/lib/routes';

const urls = () =>
  [
    {
      title: resolveRoute('base.markets', undefined, true),
      url: resolveRoute('base.markets'),
      vectorName: 'FaSackDollar'
    },
    {
      title: 'معاملات',
      vectorName: 'TbArrowsExchange2',
      url: [
        {
          title: resolveRoute('base.trade', undefined, true),
          url: resolveRoute('base.trade'),
          vectorName: 'RiP2pLine',
          description: 'خرید و فروش حرفه‌ای رمز ارز'
        },
        {
          title: resolveRoute('base.otc', undefined, true),
          url: resolveRoute('base.otc'),
          vectorName: 'SiHoppscotch',
          description: 'خرید و فروش آسان رمز ارز'
        }
      ]
    },
    {
      title: resolveRoute('base.signal', undefined, true),
      url: resolveRoute('base.signal'),
      vectorName: 'RiSignalTowerLine'
    },
    {
      title: resolveRoute('base.stacking', undefined, true),
      url: resolveRoute('base.stacking'),
      vectorName: 'BsCoin'
    },
    {
      title: resolveRoute('base.blog', undefined, true),
      url: resolveRoute('base.blog'),
      vectorName: 'ImNewspaper'
    },
    {
      title: resolveRoute('base.invitation', undefined, true),
      url: resolveRoute('base.invitation'),
      vectorName: 'MdOutlineHandshake'
    }
  ] as const;

export default function Links(props: {
  showIcons?: boolean;
  showSubIcons?: boolean;
  activeDropDown: string;
  activeDropDownRef: React.ForwardedRef<HTMLUListElement>;
  onActiveDropDown: (dropDown: string) => void;
  setIsSidebarOpen?: SetState<boolean>;
}) {
  const pathname = usePathname();

  function onClick(
    event: React.MouseEvent,
    url: ReturnType<typeof resolveRoute>
  ) {
    if (props.setIsSidebarOpen && pathname === url) {
      event.preventDefault();
      props.setIsSidebarOpen(false);
    }
  }

  return (
    <ul className={`${CSS.urls} ${CSSUtility.scrollbar}`}>
      {urls().map((item, index) =>
        typeof item.url !== 'string' ? (
          <li key={index} className={CSS.urlDropDown}>
            <Focus>
              <div
                className={CSS.urlWrapper}
                onClick={() => props.onActiveDropDown(item.title)}>
                {props.showIcons && (
                  <Vector name={item.vectorName} className={CSS.icon} />
                )}
                {item.title}
                <Vector name="IoMdArrowDropdown" svgProps={{size: '1rem'}} />
              </div>
            </Focus>

            <ul
              ref={props.activeDropDownRef}
              className={[
                CSS.dropDownMenu,
                props.activeDropDown === item.title ? CSS.open : ''
              ].join(' ')}>
              {item.url.map((item, index) => (
                <li key={index} className={CSS.urlWrapper} data-url={item.url}>
                  {props.showSubIcons && (
                    <Vector name={item.vectorName} className={CSS.icon} />
                  )}
                  <Link
                    href={item.url}
                    onClick={event => onClick(event, item.url)}>
                    {item.title}
                    <div className={CSS.description}>{item.description}</div>
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ) : (
          <li key={index} className={CSS.urlWrapper} data-url={item.url}>
            {props.showIcons && (
              <Vector name={item.vectorName} className={CSS.icon} />
            )}
            <Link
              href={item.url}
              onClick={event => onClick(event, item.url as string)}>
              {item.title}
            </Link>
          </li>
        )
      )}
    </ul>
  );
}
